import React, { useEffect, useState } from "react";
import { FormattedEvent, SpielErgebnisResult } from "../../../types";
import { useErgebnisStore, ErgebnisState } from "./ergebnisStore";
import { useLiveContext } from "../DataProvider/LiveContext/LiveContext";
import "./SpielErgebnis.css";

interface Props {
  event: FormattedEvent;
}

const SpielErgebnis: React.FC<Props> = ({ event }) => {
  const getErgebnis = useErgebnisStore((store: ErgebnisState) => store.getErgebnis);
  const hasLoadedOnce = useErgebnisStore(s => s.hasLoadedOnce);
  const { setAnyLive } = useLiveContext();
  const [ergebnis, setErgebnis] = useState<SpielErgebnisResult | null>(null);
  const [loading, setLoading] = useState(false);

  // function to fetch the ergebnis
  const fetchErgebnis = async () => {
    let active = true;
    try {
      const res: SpielErgebnisResult | null = await getErgebnis(event);
      if (active) {
        setErgebnis(res);
      }
    } finally {
      if (active) {
        setLoading(false);
      }
    }
    return () => { active = false };
  };
  
  // load spielergebnis
  useEffect(() => {
    if (event.shallLoadSpielErgebnis){
      // only show loading if it is the first render
      if(!hasLoadedOnce(event)) {
        setLoading(true);
      }
      fetchErgebnis();
    }
  }, [event.shallLoadSpielErgebnis, event.start, event.title, event.hash_id]);
  
  // also reload if app is visible again
  useEffect(() => {
    const handleVisibility = () => {
      if (event.shallLoadSpielErgebnis && document.visibilityState === "visible") {
        fetchErgebnis(); // re-fetch when tab/app becomes active
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  // global store if a spiel is live
  useEffect(() => {
    if (ergebnis?.live) {
      setAnyLive(true);
    }
  }, [ergebnis?.live, setAnyLive]);


  const ergebnisLive = ergebnis?.live
  const ergebnisLiveAndHidden = ergebnisLive && !event.shallShowLiveErgebnis
  const ergebnisNotFound = ergebnis?.ergebnis == undefined;

  return (
    <span className={
        `spielergebnis
        ${loading ? "loading" : ""}
        ${!loading && (!event.shallLoadSpielErgebnis || ergebnisLiveAndHidden || ergebnisNotFound) ? "hidden" : "" }
        ${ergebnisLive ? "live" : ""}`
      }>
      <a href={ergebnis?.link} target="_blank" rel="noopener noreferrer">
        {loading ? "" : (ergebnis?.ergebnis || "?") }
      </a>
    </span>
  );
};

export default SpielErgebnis;
